import { Component, Input, OnInit } from '@angular/core';
import { CompanyType } from 'src/app/settings/constants';
import constants from 'src/app/shared/constants';
import { AuthService } from 'src/app/auth/services/auth.service';

@Component({
  selector: 'app-configuration-list-component',
  templateUrl: './configuration-list-component.html',
  styleUrls: ['./configuration-list-component.scss'],
})
export class ConfigurationListComponent implements OnInit {
  @Input() company: CompanyType;

  displayedColumns: string[] = ['name', 'apiKey', 'ip', 'monitoringPort', 'receiverEventPort', 'snifferPort'];
  dataSource: any[];

  show = false;

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.dataSource = this.company.receivers;
  }

  isLast(item: any, array: string | any[]) {
    return array[array.length - 1] === item;
  }

  onKaironIsEnabledChange(company: any, newValue: boolean) {
    if (company.kairon?.isEnabled !== newValue) {
      company.kairon.isEnabled = newValue;
    }
  }

  isKaironEnabled(company: any) {
    return this.authService.isFeatureFlagEnabled(constants.featureFlags.iaKairon, company._id);
  }

  isMaiaEnabled(company: any) {
    return this.authService.isFeatureFlagEnabled(constants.featureFlags.iaMaia, company._id);
  }
}
